import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TaskComplete from "../common/taskComplete";
import GeneralForm from "../forms/pageForms/generalForm";

export default function General({
  user,
  userData,
  shake,
  updatePage,
  pullUserData
}) {
  const { t } = useTranslation();
  return (
    <>
      {/* {userData.general ? (
        <section className="main-section">
          <h2>General Information</h2>
          <section className="main-section-content">
            <TaskComplete
              pageTitle={"General Information"}
              nextLink="phase2-residences"
            />
          </section>
        </section>
      ) : (
        <> */}
          {/* Instructions   */}
          <section className="main-section">
            <h2>{t("general.title")}</h2>
            <div className="main-section-content text-start">
              <p>{t("general.completeForm")}</p>
              <p>{t("general.submitInstructions")}</p>
              <p className="alert alert-info">{t("general.pageRequirements")}</p>
            </div>
          </section>

          {/* Form  */}
          <section className="main-section">
            <div className="main-section-content">
              <Container>
                <GeneralForm
                  nextLink={"phase2-residences"}
                  shake={shake}
                  updatePage={updatePage}
                  userData={userData}
                  pullUserData={pullUserData}
                />
              </Container>
            </div>
          </section>
        {/* </>
      )} */}
    </>
  );
}
